import { createAction, props } from '@ngrx/store';
export const setFundChartSortDirection = createAction('[Fund Chart] Set Sort Direction', props());
